var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"truncate-length":"30","show-size":"","label":_vm.itemAction.name,"accept":_vm.itemAction.accept,"value":_vm.value,"outlined":"","dense":""},on:{"change":_vm.selectFile}})
}
var staticRenderFns = []

export { render, staticRenderFns }